import React, { useEffect, useState, useRef } from "react";
import { Card, Row, Col, Button, Badge, Table } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { BiLoader, BiShare, BiLink, BiFile, BiArrowBack, BiTrash, BiSolidStar } from "react-icons/bi";
import { Formik } from "formik";
import { getUserData } from "../../utils/common";
import { makeRequest } from "../../utils/makeRequest";
import * as urls from '../../utils/urlConst';
import toastNotify from "../../utils/toastNotify";
import Loader from "../../components/Loader";
import SelectField from "../../components/textField/SelectField";
import { converToBase64 } from "../../utils/common";
import JSZip from "jszip";
import { useSelector } from "react-redux";
import { userDataProps } from "../../App";
import { exceptionLog } from "../../utils/common";
import { checkFileMimeType } from "../../apiService/apiService";
import Editor from "../../components/textEditor/Editor";
import { useParamters } from "../../hooks/hooks";
import TicketFeedbackMdl from "./TicketFeedbackMdl";

type ticketPosProps = {
  Description: string,
  FileStatus: string,
  PostLastActivity: string,
  PostTranCode: string,
  PostType: string,
  ReplayBy: string,
  FeedBackExistStatus?: string,
  FeedBackRating?: string,
}

type statusDataProps = {
  StatusFor: string,
  StatusName: string,
  StatusType: string,
  TranCode: string,
}

const ViewDetails = () => {
  const [replySection, setReplySection] = useState<boolean>(false);
  const { state } = useLocation();
  const [getTicketPost, setGetTicketPost] = useState<ticketPosProps[]>([]);
  const [toggleDescription, setToggleDescription] = useState<any>({});
  const [isLoader, setIsLoader] = useState<boolean>(false);
  const [isPostLoader, setIsPostLoader] = useState<boolean>(false);
  const [getStatusData, setGetStatusData] = useState<statusDataProps[]>([]);
  const userData: userDataProps = getUserData();
  const navigate = useNavigate();
  const fetchTicketDetails = useSelector((states: any) => states.ticket.reCallTicketDetails);
  const [currentActiveId, setCurrentActiveId] = useState<any>(null);
  const [isFeedbackMdl, setIsFeedbackMdl] = useState<boolean>(false);
  const [closedTicket, setClosedTicket] = useState<any>(null);

  const handleFeedbackMdl = () => setIsFeedbackMdl(!isFeedbackMdl);

  const parameters = useParamters(["7011", "7006"]);

  const attechmentSize = parameters.find((items: any) => items.paraCode === "7011").paraValue;
  const bypassToMimeType = parameters.find((items: any) => items.paraCode === "7006").paraValue;

  const removeTag = (data: any) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = data;
    return tempDiv.textContent || tempDiv.innerText
  }

  const handleDataToggle = (id: number) => {
    if (currentActiveId !== null) {
      setToggleDescription((preState: any) => ({ ...preState, [currentActiveId]: false }));
    };
    setCurrentActiveId(id);
    setToggleDescription((preState: any) => ({ ...preState, [id]: !toggleDescription[id] }));
  };


  // ** this function called ticket post List API start **
  const fetchPost = async () => {
    try {
      setIsLoader(true);
      const payload = {
        TicketId: state.response.TicketData,
      };
      const config = {};
      await makeRequest('POST', urls.getTicketPost, payload, config).then((result) => {
        if (result.STATUS === '0') {
          const response = result.RESPONSE;
          setGetTicketPost(response);
        } else {
          setGetTicketPost([]);
          result.MESSAGE !== "No Data Found" && toastNotify(result.MESSAGE, 'error');
        }
      })
    } catch (error: any) {
      if (error.status !== 403) {
        await exceptionLog(error, "Get ticket post", "N");
      }
    } finally {
      setIsLoader(false);
    }
  };

  // ** this function called Status Dropdown API start **
  const fetchStatus = async () => {
    try {
      setIsLoader(true);
      const payload = {};
      const config = {};
      await makeRequest('POST', urls.getTicketStatus, payload, config).then((result) => {
        if (result.STATUS === '0') {
          const response = result.RESPONSE;
          setGetStatusData(response);
        } else {
          setGetStatusData([]);
          result.MESSAGE !== "No Data Found" && toastNotify(result.MESSAGE, 'error');
        }
      })
    } catch (error: any) {
      if (error.status !== 403) {
        await exceptionLog(error, "Get ticket status", "N");
      }
    } finally {
      setIsLoader(false);
    }
  }

  useEffect(() => {
    const handleData = async () => {
      await fetchPost();
      await fetchStatus();
    }
    handleData();
  }, []);

  const attanchmentRef = useRef<any>(null);
  const attachfiles = () => {
    attanchmentRef.current.click();
  };


  const [multiFile, setMultiFile] = useState<any[]>([]);
  const handleMultiFile = (e: React.ChangeEvent<any>) => {
    const files = e.target.files;
    let fileSize: any = 0;

    if (files && files.length > 0) {
      Array.from(files).forEach((file: any) => {
        fileSize = parseFloat(fileSize) + parseFloat((file.size / 1048576).toFixed(2));
      });

      if (Number(fileSize) > Number(attechmentSize)) {
        setMultiFile([]);
        return toastNotify(`File size less then ${attechmentSize} MB`, 'error');
      } else {
        Array.from(files).forEach((file: any) => {
          const reader: any = new FileReader();
          reader.onloadend = () => {
            let mimeType: any;

            if (bypassToMimeType === "N" || file?.type !== "text/plain") {
              mimeType = checkFileMimeType(reader);
            }
            if (mimeType === 'unknown' || bypassToMimeType === "N") {
              return toastNotify('Invaid file format', 'error');
            } else if (Number(fileSize) > Number(attechmentSize)) {
              return toastNotify(`File size less then ${attechmentSize} MB`, 'error');
            };
            setMultiFile((prevent: any) => [...prevent, file]);
          };
          reader.readAsArrayBuffer(file);
        });
      }
    };
  };

  // ** this function create ZIP of added files start **
  const generateZipFile = async () => {
    const zip = new JSZip();
    if (multiFile.length > 0) {
      multiFile.forEach((items) => {
        zip.file(items.name, items);
      });
      const content: any = await zip.generateAsync({ type: 'blob' });
      const base64: any = await converToBase64(content);
      return base64.split(",")[1];
    } else {
      return "";
    }
  };

  // ** this function called added post API start **

  const addTicketPost = async (val: any, resetForm: any) => {
    try {
      setIsPostLoader(true);
      const attechFile = await generateZipFile();
      const payload = {
        TicketId: state.response.TicketData,
        Description: val.description,
        ZipBase64: attechFile,
      };
      const config = {};
      await makeRequest('POST', urls.addTicketPost, payload, config).then((result) => {
        if (result.STATUS === '0') {
          toastNotify(result.MESSAGE, 'success');
          resetForm();
          fetchPost();
          setMultiFile([]);
          setReplySection(false);
        } else {
          toastNotify(result.MESSAGE, 'error');
        }
      })
    } catch (error: any) {
      if (error.status !== 403) {
        await exceptionLog(error, "Add ticket post", "N");
      }
    } finally {
      setIsPostLoader(false);
    }
  };

  // ** this function called Ticket status updated start **

  const updateTicket = async (val: any, resetForm: any) => {
    try {
      setIsPostLoader(true);
      const payload = {
        TicketId: state.response.TicketData,
        Priority: state.response.Priority,
        TicketStatus: val.statusCD,
        TicketStatusType: val.statusType
      };
      const config = {};
      await makeRequest('POST', urls.updateTicketStatus, payload, config).then((result) => {
        if (result.STATUS === '0') {
          toastNotify(result.MESSAGE, 'success');
          resetForm();
          fetchPost();
          setReplySection(false);
          // this reload to updated ticket details
          fetchTicketDetails(state.response.TicketData);

          if (val.statusType === "C" && state.response.FeedbackFlag !== "Y") {
            handleFeedbackMdl();
            setClosedTicket(state.response.TicketData);
          }
        } else {
          toastNotify(result.MESSAGE, 'error');
        }
      })
    } catch (error: any) {
      if (error.status !== 403) {
        await exceptionLog(error, "Update ticket status", "N");
      }
    } finally {
      setIsPostLoader(false);
    }
  };

  // ** this function Called downloaded attched file start **

  const downloadAttechFiles = async (TranCode: string, postType: string) => {
    try {
      setIsLoader(true);
      const payload = {
        TranCode: TranCode,
        PostStatus: postType,
      };
      const config = {};
      await makeRequest('POST', urls.downloadAttechFiles, payload, config).then((result) => {
        if (result.STATUS === '0') {
          toastNotify(result.MESSAGE, 'success');
          const response = result.RESPONSE[0];
          downloadZipFile(response.FileString, response.FileName)
        } else {
          toastNotify(result.MESSAGE, 'error');
        }
      })
    } catch (error: any) {
      if (error.status !== 403) {
        await exceptionLog(error, "Download attech files", "N");
      }
    } finally {
      setIsLoader(false);
    }
  };

  // ** this function downloaded attched file start **

  const downloadZipFile = (base64Data: string, fileName: string) => {
    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'aplication/zip' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };


  return (
    <div>
      <div className="mb-3 d-flex align-items-center">
        <div>
          <h2 className="text-base pe-md-2 mb-0">Ticket Details</h2>
        </div>
        <Button variant="outline-secondary ms-auto" className="btn-sm" onClick={() => navigate("/tickets")}>
          <BiArrowBack className="me-2" />
          Back
        </Button>
      </div>

      <Card>
        <Card.Body className="py-0">
          <Row className="TicketDetailsContainer">
            <Col md={3} className="p-3 ticketDetails">

              <div className="d-grid gap-0 row-gap-3">
                <div>
                  <div className="text-slate-500 text-xs">Ticket Id</div>
                  <div className="text-sm">#{state.response.TicketData}</div>
                </div>

                <div>
                  <div className="text-slate-500 text-xs">Ticket Created Date</div>
                  <div className="text-sm">{state.response.CreateDate}</div>
                </div>

                <div>
                  <div className="text-slate-500 text-xs">Status</div>
                  <div>
                    {state.response.StatusName === 'O' && <Badge bg="success">Open</Badge>}
                    {state.response.StatusName === 'C' && <Badge bg="danger">Closed</Badge>}
                    {state.response.StatusName === 'P' && <Badge bg="primary">Pending</Badge>}
                    {state.response.StatusName === 'I' && <Badge bg="warning">In-Process</Badge>}
                    {state.response.StatusName === 'R' && <Badge bg="success">Re-Open</Badge>}
                    {state.response.StatusName === 'A' && <Badge bg="info">Assigned</Badge>}
                    {state.response.StatusName !== 'O' && state.response.StatusName !== 'C' && state.response.StatusName !== 'P' && state.response.StatusName !== 'I' && state.response.StatusName !== 'R' && state.response.StatusName !== 'A' ? <Badge bg="warning">{state.response.StatusName}</Badge> : ''}
                  </div>
                </div>

                {state.response.LastAssignUser !== "" &&
                  <div>
                    <div className="text-slate-500 text-xs">Last User Assign</div>
                    <div className="text-sm">{state.response.LastAssignUser}</div>
                  </div>
                }

                <div>
                  <div className="text-slate-500 text-xs">Category</div>
                  <div className="text-sm">{state.response.CategoryName}</div>
                </div>

                {state.response.SubCategoryName !== '' &&
                  <div>
                    <div className="text-slate-500 text-xs">Sub-category</div>
                    <div className="text-sm">{state.response.SubCategoryName}</div>
                  </div>
                }

                {state.response.BranchName !== "" &&
                  <div>
                    <div className="text-slate-500 text-xs">Branch Name</div>
                    <div className="text-sm">{state.response.BranchName}</div>
                  </div>
                }

                {state.response.OrganizationName !== "" &&
                  <div>
                    <div className="text-slate-500 text-xs">Organization</div>
                    <div className="text-sm">{state.response.OrganizationName}</div>
                  </div>
                }

                <div>
                  <div className="text-slate-500 text-xs">Classification</div>
                  <div className="text-sm">
                    {state.response.ClassificationCode === 'Q' && 'Question'}
                    {state.response.ClassificationCode === 'P' && 'Problem'}
                    {state.response.ClassificationCode === 'F' && 'Feature'}
                    {state.response.ClassificationCode === 'O' && 'Other'}
                  </div>
                </div>

                <div>
                  <div className="text-slate-500 text-xs">Ticket Type</div>
                  <div className="text-sm">
                    {state.response.TicketType === 'S' && 'Service'}
                    {state.response.TicketType === 'T' && 'Transation'}
                  </div>
                </div>

                <div>
                  <div className="text-slate-500 text-xs">Priority</div>
                  <div>
                    {state.response.Priority === 'H' && <Badge bg="danger">High</Badge>}
                    {state.response.Priority === 'M' && <Badge bg="warning">Medium</Badge>}
                    {state.response.Priority === 'L' && <Badge bg="success">Low</Badge>}
                  </div>
                </div>

                {state.response.DynamicColumns.map((items: { ColumnVal: string, LabelName: string }, id: number) => (
                  <div key={id}>
                    <div className="text-slate-500 text-xs">{items.LabelName}</div>
                    <div className='text-sm'>{items.ColumnVal}</div>
                  </div>
                ))}

                {state.response.TransactionDetail.length > 0 &&
                  <div>
                    <div className="text-slate-500 text-xs">Transaction Details</div>
                    <Table bordered hover responsive className="mt-3">
                      <thead>
                        <tr>
                          <th className="text-slate-700 text-xs text-center">Trn. Ref. No.</th>
                          <th className="text-slate-700 text-xs text-center">Trn. Date</th>
                          <th className="text-slate-700 text-xs text-center">Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        {state.response.TransactionDetail.map((items: any, id: number) => (
                          <tr key={id}>
                            <td className="text-xs text-slate-700">
                              {items.TranRefNo}
                            </td>
                            <td className="text-xs text-slate-700">
                              {items.TranDate}
                            </td>
                            <td className="text-xs text-slate-700">
                              &#8377; {items.TranAmount}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                }
              </div>
            </Col>

            <Col md={9} className="p-3 ticketDetails border-0">
              <div className="d-flex align-items-center">
                <h5
                  style={{
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    width: "75%",
                  }}
                  className="mb-0 text-base"
                >
                  {state.response.Subject}
                </h5>
                {state.response.TicketActive === "Y" ?
                  <>
                    {userData.TicketPermanentCloseStatus !== "B" && userData.TicketPermanentCloseStatus !== "A" ?
                      <div className="ms-auto">
                        <Button
                          type="button"
                          variant={`${replySection ? 'outline-secondary' : "orange"} `}
                          className="btn-sm"
                          onClick={() => {
                            setReplySection(!replySection);
                          }}
                        >
                          {replySection ? <>Back</> :
                            <>
                              <BiShare className="text-white me-1" />
                              Reply
                            </>
                          }
                        </Button>
                      </div>
                      : ""}
                  </>
                  : ""}
              </div>
              <hr className="mb-0" />

              <div>
                {/* reply part start */}
                {replySection && (
                  <div className="border-bottom p-3">
                    <Formik
                      initialValues={{ description: '', statusCD: "", statusLabel: "", statusType: "", attachFile: [] }}
                      onSubmit={async (values, { resetForm }) => {
                        if (values.description !== '' && values.statusCD !== '') {
                          await addTicketPost(values, resetForm);
                          await updateTicket(values, resetForm)
                        } else if (values.description !== '') {
                          await addTicketPost(values, resetForm);
                        } else if (values.statusCD !== '') {
                          await updateTicket(values, resetForm)
                        } else {
                          toastNotify("Please fill message or status.", 'error');
                        }
                      }}
                    >
                      {({ values, handleSubmit, setFieldValue }) => {
                        return (
                          <form onSubmit={handleSubmit}>
                            <div className="d-flex">
                              <div
                                style={{ width: 40, height: 40 }}
                                className="border border-orange text-orange rounded-circle d-flex justify-content-center align-items-center text-uppercase me-2"
                              >
                                {userData.FirstName.charAt(0)}
                              </div>

                              <Row className="w-100" >
                                <Col md={12}>
                                  <Editor
                                    label="Description"
                                    required
                                    placeholder="write your content ...."
                                    value={values.description}
                                    onChange={(e: any) => setFieldValue("description", e)}
                                  />
                                </Col>

                                <Col md={6} className="mt-3">
                                  <SelectField
                                    name="status"
                                    required
                                    options={getStatusData.map((items) => ({
                                      value: items.TranCode, label: items.StatusName, StatusType: items.StatusType, StatusFor: items.StatusFor
                                    }))}
                                    placeholder='Status'
                                    onChange={(e: any) => { setFieldValue("statusCD", e?.value); setFieldValue("statusLabel", e?.label); setFieldValue("statusType", e?.StatusType) }}
                                  />
                                </Col>

                                <Col md={6}></Col>

                                <Col md={6} className='mt-3'>
                                  <input
                                    type="file"
                                    name="attachFile"
                                    multiple
                                    className="d-none"
                                    ref={attanchmentRef}
                                    accept={`.png,.jpeg,.jpg,.pdf,.xls,.xlsx,.doc,.docx,.ppt,.pptx,.eml,.msg,${bypassToMimeType === "Y" ? ".txt" : ""}`}
                                    onChange={(e: any) => {
                                      const selectFiles = e.target.files;
                                      setFieldValue('attachFile', selectFiles);
                                      handleMultiFile(e)
                                    }}
                                  />

                                  <span
                                    className="d-flex align-items-center"
                                    onClick={attachfiles}
                                    style={{ cursor: "pointer" }}
                                  >
                                    <div
                                      className="border rounded-circle d-flex justify-content-center align-items-center me-2 border-oragne"
                                      style={{ width: 35, height: 35 }}
                                    >
                                      <BiLink className="text-oragne" />
                                    </div>
                                    <div>
                                      <h5 className="text-sm mb-0">
                                        Attach a file
                                      </h5>
                                      <div className="text-xs text-slate-500">Up to {attechmentSize} MB</div>
                                    </div>
                                  </span>

                                  <div className='mt-3'>
                                    {multiFile.map((file: any, id: number) => {
                                      const fileSize: any = file.size >= 1024 ? (file.size / 1048576).toFixed(2) + " MB" : (file.size / 1024).toFixed(2) + " KB"
                                      return (
                                        <div
                                          key={id}
                                          className="d-flex align-items-center mt-3"
                                        >
                                          {file.type === "image" ?
                                            <div
                                              className="border rounded-circle d-flex justify-content-center align-items-center me-3"
                                              style={{ width: 35, height: 35 }}
                                            >
                                              <img src={file ? URL.createObjectURL(file) : ""} alt={file.name} className="w-100 h-100 rounded-circle" />
                                            </div>
                                            :
                                            <div
                                              className="border rounded-circle d-flex justify-content-center align-items-center me-3"
                                              style={{ width: 35, height: 35 }}
                                            >
                                              <BiFile />
                                            </div>
                                          }
                                          <div>
                                            <h5 className="text-sm mb-1">{file.name}</h5>
                                            <div className="text-xs text-slate-500">File Size : {fileSize}</div>
                                          </div>
                                          <Button variant='outline-danger' className='rounded-circle btn-sm ms-auto'
                                            onClick={() => {
                                              let newValue = [...values.attachFile];
                                              newValue.splice(id, 1);
                                              setFieldValue('attachFile', newValue);

                                              let selectedFile = [...multiFile];
                                              selectedFile.splice(id, 1);
                                              setMultiFile(selectedFile);
                                            }}>
                                            <BiTrash className="text-danger" />
                                          </Button>
                                        </div>
                                      )
                                    })}
                                  </div>
                                </Col>

                                <Col md={12}>
                                  <div className="mt-3">
                                    <Button type="submit" variant="orange" className="btn-sm">
                                      {!isPostLoader ? 'Status & Post Update' : <><BiLoader className='icon-loader text-white text-lg' /> Loading...</>}
                                    </Button>
                                  </div>
                                </Col>
                              </Row>
                            </div>
                          </form>
                        )
                      }}
                    </Formik>
                  </div>
                )}

                {/* reply part end */}

                {!isLoader ?
                  <div className="border rounded mt-3">
                    {getTicketPost.map((item, id) => {
                      return (
                        <div className="border-bottom p-2" key={id}>
                          <div
                            className="d-flex"
                            style={{ cursor: "pointer" }}
                            onClick={() => handleDataToggle(id)}
                          >
                            {/* <div
                              style={{ width: 40, height: 40 }}
                              className="border rounded-circle d-flex justify-content-center align-items-center me-2 border-orange text-orange text-uppercase"
                            >
                              {item?.FeedBackExistStatus === "Y" ? <BiSolidStar style={{ color: "#ccc !important", fontSize: 25 }} /> : item.ReplayBy.charAt(0)}
                            </div> */}

                            <div
                              style={{ width: 40, height: 40 }}
                              className="border rounded-circle d-flex justify-content-center align-items-center me-2 border-orange text-orange text-uppercase position-relative"
                            >
                              {item?.FeedBackExistStatus === "Y" ? <BiSolidStar style={{ color: "#ccc !important", fontSize: 25 }} /> : item.ReplayBy.charAt(0)}

                              {item.FileStatus === 'Y' &&
                                <div style={{ width: 20, height: 20, top: "-5px", left: "-5px" }} className='position-absolute d-flex justify-content-center align-items-center rounded-circle attachment-badge'>
                                  <BiFile style={{ fontSize: 12 }} />
                                </div>
                              }
                            </div>

                            <div>
                              <h2 className="text-base mb-0 text-capitalize">{item?.FeedBackExistStatus === "Y" ? "Feedback By " + item.ReplayBy : item.ReplayBy}</h2>
                              <div className="text-xs text-slate-500">{item.PostLastActivity}</div>
                            </div>
                          </div>

                          <div className="mt-3 Pop-up ">
                            {toggleDescription[id] ? (
                              <>

                                {item?.FeedBackExistStatus === "Y" &&
                                  <div className="star-rating-section mt-2 mb-3">
                                    {[1, 2, 3, 4, 5].map((i) => (
                                      <div
                                        key={i}
                                        className={` ${Number(item?.FeedBackRating) >= i ? "active" : ""} `}
                                      >
                                        <BiSolidStar style={{ color: "#ccc !important", fontSize: 25 }} />
                                      </div>
                                    ))}
                                  </div>
                                }

                                <div className='ql-editor'>
                                  <div dangerouslySetInnerHTML={{ __html: item.Description }} />
                                </div>

                                {item.FileStatus === 'Y' &&
                                  <div className="my-3">
                                    <div>
                                      <div className='zip-download-btn text-sm d-flex align-items-center justify-content-center' onClick={() => downloadAttechFiles(item.PostTranCode, item.PostType)}><span>Download</span><span>ZIP File</span></div>
                                    </div>
                                  </div>
                                }
                              </>
                            ) : (
                              <p
                                style={{
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  width: "100%",
                                }}
                                className='text-sm mb-0'
                              >
                                {removeTag(item.Description)}
                              </p>
                            )}
                          </div>
                        </div>
                      )
                    })}
                  </div>
                  :
                  <div style={{ height: 300 }} className='d-flex justify-content-center align-items-center'>
                    <Loader />
                  </div>
                }
              </div>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      {isFeedbackMdl &&
        <TicketFeedbackMdl isShow={isFeedbackMdl} handleFeedbackMdl={handleFeedbackMdl} closedTicket={closedTicket} setClosedTicket={setClosedTicket} fetchPost={fetchPost} />
      }
    </div>
  );
};

export default ViewDetails;
